import { useContext } from "react";
import { BNIdentityCtx } from "../context/BNIdentityCtx";
export var useBNIdentity = function () {
    var ctxConsumer = useContext(BNIdentityCtx);
    return ctxConsumer;
};
//# sourceMappingURL=useBNIdentity.js.map